export const getLocalizedRoute = (path: string, locale: string, formater: any) => {
   return `/${locale}` + formater({ id: path });
}
